export default defineNuxtRouteMiddleware((to, from) => {
    // クエリパラメーターに'ID'または'ID2'が存在している場合のみパラメータを小文字に変換する
    if ('ID' in to.query || 'ID2' in to.query) {
      const lowerCaseQuery: Record<string, string> = {}
      for (const key in to.query) {
        if (Object.prototype.hasOwnProperty.call(to.query, key)) {
          const value = to.query[key];
          // to.query[key]がnullでなく、undefinedでないことを確認する
          if (value !== null && typeof value !== 'undefined') {
            // to.query[key]がstring型であることを保証する
            if (typeof value === 'string' || value instanceof String) {
              lowerCaseQuery[key.toLowerCase()] = value.toString();
            }
          }
        }
      }
      to.query = lowerCaseQuery;
    }

    // to.query.id, to.query.id2がstring型であることを保証する
    const id = typeof to.query.id === 'string' ? to.query.id : '';
    const id2 = typeof to.query.id2 === 'string' ? to.query.id2 : '';
    
    // promCodeとpromCode2のCookieを定義
    const promCode = useCookie('promCode', {
      maxAge: 1000 * 60 * 60 * 24 * 365,
      // httpOnly: true,
      secure: false
    })

    const promCode2 = useCookie('promCode2', {
      maxAge: 1000 * 60 * 60 * 24 * 365,
      // httpOnly: true,
      secure: false
    })

    // IDがある場合はpromCodeに格納
    if (id) {
      promCode.value = id;
    }
    if(!promCode.value) {
      promCode.value = 'aaaaa00000'
    }

    // promCode2の設定ロジック
    // 1. ID2パラメータがある場合: ID2の値を設定
    if (id2) {
      promCode2.value = id2;
    }
    // 2. IDパラメータのみある場合: IDの値でpromCode2を更新（promCodeと同期）
    else if (id) {
      promCode2.value = promCode.value;
    }
    // 3. 初回訪問時（IDもID2もなく、promCode2が未設定）: promCodeの初期値で設定
    else if (!promCode2.value) {
      promCode2.value = promCode.value;
    }
    // 4. 通常のページ遷移（パラメータなし＆promCode2に既存値あり）: 既存値を保持
    
})